export default "__VITE_ASSET__p31xiJw$__"